module.exports = __webpack_public_path__ + "static/img/Daly-CherryEvans.a3a6161.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Daly-CherryEvans.jpg
// module id = zsWg
// module chunks = 0